const ERRORS = {
    forbiddenInEditMode: 'This service is disabled in author mode'
};

export const apiUrl = endPointName => `/sling/servlet/default/.${endPointName}.json`;

export const getDataFromApi = async (apiEndPoint, body = null) => {
    if(window.editMode) {
        throw new Error(ERRORS.forbiddenInEditMode);
    }

    try {
        const response = await fetch(apiUrl(apiEndPoint), {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: body && JSON.stringify(body)
        });

        if(response.ok) {
            return response.json();
        }

        throw new Error(`Call to api ${apiUrl} failed. HTTP status: $ ${response.status}`);
    } catch (error) {
        throw new Error(`Call to api ${apiUrl} failed. HTTP status: $ ${error}`);
    }
};
